module.exports = __webpack_public_path__ + "img/VoyageBelek.47e2615f.png";